import { Panel } from 'components/Modals/commonStyles';
import styled from 'styled-components';

export const TotalNetDownPaymentPanel = styled(Panel)`
  margin-bottom: 20px;
`;
